export function Avatar({ src, name, className = '' }: { src?: string; name: string; className?: string }) {
  return (
    <span
      className={`avatar ${className}`}
      style={src ? { backgroundImage: `url("${src}")` } : undefined}
      aria-hidden="true"
    >
      {src ? '' : name.slice(0, 1).toUpperCase()}
    </span>
  );
}
